<template>
  <nav class="navbar" :class="{ hidden: isHidden, 'show-bg': isShowBg }">
    <div class="content-center">
      <div class="logo">
        <img src="@/assets/images/logo.png" alt="Logo" @mouseover="showNav">
      </div>
      <ul class="nav-menu">
        <li class="nav-item" :class="{ active: isActive('/home') }">
          <router-link to="/">
            首页
          </router-link>
        </li>
        <li class="nav-item" :class="{ active: isActive('/about') }">
          <router-link to="/about">
            关于我们
          </router-link>
          <ul class="dropdown">
            <li>
              <a href="javascript:;" @click="goAbout('introduction')">机构简介</a>
            </li>
            <!-- <li>
              <a href="javascript:;" @click="goAbout('rules')">规章制度</a>
            </li> -->
            <li>
              <a href="javascript:;" @click="goAbout('structure')">组织架构</a>
            </li>
            <li>
              <a href="javascript:;" @click="goAbout('party')">党建工作</a>
            </li>
          </ul>
        </li>
        <li class="nav-item" :class="{ active: isActive('/projects') }">
          <router-link to="/projects">
            公益项目
          </router-link>
        </li>
        <li class="nav-item" :class="{ active: isActive('/arete') }">
          <router-link to="/arete">
            爱德说
          </router-link>
        </li>
        <li class="nav-item" :class="{ active: isActive('/info') }">
          <router-link to="/info">
            信息公开
          </router-link>
          <ul class="dropdown">
            <li v-for="item in PublicInfoEnum" :key="item.value">
              <a href="javascript:;" @click="goInfo(item.value)">{{ item.text }}</a>
            </li>
          </ul>
        </li>
        <li class="nav-item" :class="{ active: isActive('/news') }">
          <router-link to="/news">
            资讯
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import publicInfoEnum from '@/mixins/publicInfoEnum'

export default {
  name: 'NavBar',
  mixins: [publicInfoEnum],
  data () {
    return {
      isHidden: false,
      isShowBg: false,
      PublicInfoEnum: []
    }
  },
  mounted () {
    this.throttledHandleScroll = this.throttle(this.handleScroll, 200)
    window.addEventListener('scroll', this.throttledHandleScroll)
    document.addEventListener('click', this.handleClickOutside)
    this.isNavVisible = false
    this.getOptionConvert()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.throttledHandleScroll)
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    goAbout (locationId) {
      this.$router.push({ name: 'About', query: { locationId } }).catch(err => {
        if (err.name !== 'NavigationDuplicated') { throw err }
      })
      this.$bus.$emit('aboutScrollTo', locationId)
    },
    goInfo (tabKey) {
      this.$router.push({ name: 'Info', query: { tabKey } }).catch(err => {
        if (err.name !== 'NavigationDuplicated') { throw err }
      })
    },
    isActive (route) {
      return this.$route.path === route
    },
    showNav () {
      this.isHidden = false
      this.isNavVisible = true
      const scrollTop = this.getScrollTop()
      this.isShowBg = scrollTop > 60
    },
    hideNav () {
      this.isHidden = true
      this.isNavVisible = false
    },
    handleScroll () {
      const scrollTop = this.getScrollTop()
      if (!this.isNavVisible) {
        this.isHidden = scrollTop > 60
      } else {
        this.isShowBg = scrollTop > 60 && !this.isHidden
      }
    },
    handleClickOutside (event) {
      if (!this.$el.contains(event.target)) {
        const scrollTop = this.getScrollTop()
        if (scrollTop > 60) {
          this.isHidden = true
          this.isShowBg = false
          this.isNavVisible = false
        }
      }
    },
    getScrollTop () {
      return document.documentElement.scrollTop || document.body.scrollTop || 0
    },
    throttle (func, limit) {
      let lastFunc
      let lastRan
      return function () {
        const context = this
        const args = arguments
        if (!lastRan) {
          func.apply(context, args)
          lastRan = Date.now()
        } else {
          clearTimeout(lastFunc)
          lastFunc = setTimeout(function () {
            if ((Date.now() - lastRan) >= limit) {
              func.apply(context, args)
              lastRan = Date.now()
            }
          }, limit - (Date.now() - lastRan))
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.content-center {
  display: flex;
  position: absolute;
}

.navbar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  padding-top: 40px;
  padding-bottom: 10px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  transition: opacity 0.3s;

  &.show-bg {
    background: #fff;
  }
}

.navbar.hidden .nav-menu {
  opacity: 0;
  pointer-events: none;
}

.logo {
  position: absolute;
  left: -69px;
  cursor: pointer;
}

.logo img {
  display: inline-block;
  width: 40px;
  height: 40px;
}

.nav-menu {
  display: flex;
}

.nav-item {
  position: relative;
  width: 86px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin-right: 24px;
}

.nav-item a {
  text-decoration: none;
  color: rgba(0, 0, 0, 0.9);
  padding: 5px 0;
}

.nav-item.active a {
  font-weight: 500;
  border-bottom: 2px solid #98c01a;
}

.dropdown {
  display: none;
  position: absolute;
  width: 88px;
  top: calc(100% + 10px);
  left: 0;
  background-color: #fff;
  list-style: none;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  &::before {
    content: '';
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    border-width: 0 10px 10px 10px;
    border-style: solid;
    border-color: transparent transparent #fff transparent;
  }
}

.nav-item:hover .dropdown {
  display: block;
}

.dropdown li {
  height: 40px;
}

.dropdown li a {
  display: block;
  font-weight: normal !important;
  border-bottom: 0 !important;

  &:hover {
    background: #eff7f2;
    color: #98c01a;
  }
}

@media screen and (max-width: 1450px) {
  .logo {
    left: -50px;
  }
}
</style>
